import { Columns } from '@shared/interfaces/table/column-config';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';

/**
 * BusinessReasonCode Translation Column
 */
export const businessReasonCodePartial: Columns<any> = {
  title: 'table.businessreasoncode.title',
  key: 'businessReasonCode',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    'firstsettlement': 'enum.settlement.businessreasoncode.firstsettlement',
    'secondsettlement': 'enum.settlement.businessreasoncode.secondsettlement',
    'thirdsettlement': 'enum.settlement.businessreasoncode.thirdsettlement',
    'latestavailablevalue': 'enum.settlement.businessreasoncode.latestavailablevalue',
    'correctionsettlement': 'enum.settlement.businessreasoncode.correctionsettlement',
    'temporary': 'enum.settlement.businessreasoncode.temporary',
    'notspecified': 'enum.settlement.businessreasoncode.notspecified',
  }
}
